import { createBeam } from "@randajan/bifrost/client/beam";
import { bifrost } from "../bifrost";


export const globalStatsBeam = createBeam(bifrost, "/game/stats/global");



